import { render, staticRenderFns } from "./VideoYoutube.vue?vue&type=template&id=6ade92ee&scoped=true"
import script from "./VideoYoutube.vue?vue&type=script&lang=ts"
export * from "./VideoYoutube.vue?vue&type=script&lang=ts"
import style0 from "./VideoYoutube.vue?vue&type=style&index=0&id=6ade92ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade92ee",
  null
  
)

export default component.exports